<template>
  <div class="wrap">
    <div class="profile profile-1 flex flex-vc">
      <div class="avatar">
        <img :src="userInfo.avatar ? userInfo.avatar : defaultAvatar" @click="(_) => (this.show = !this.show)" />
        <van-image-preview v-model="show" :images="[userInfo.avatar]" v-show="userInfo.avatar" />
      </div>
      <div class="info flex-1">
        <div class="name">
          <div>{{ userInfo.name }}</div>
        </div>
        <div class="phone flex flex-vc" v-if="userInfo.mobile">
          <div>手机号: </div>
          <div v-if="!isEdit">
            {{ userInfo.mobile }}
          </div>
          <input class="phoneIpt" v-else ref="tt" disabled="false" autofocus v-model="userInfo.mobile"
            @blur="changeMsg" />
          <span v-if="errmsg" class="errmsg">手机号格式有误</span>
        </div>
      </div>
      <div>
        <!-- <van-icon :name="iconName" @click="iconChange(isEdit)" /> -->
        <!-- <el-button
          size="medium"
          :type="btnValue == '保存' ? 'primary' : ''"
          style="
            transform: scale(0.7);
            font-size: 1.5rem;
            padding: 0.5rem 0.8rem;
          "
          @click="iconChange(isEdit)"
          >{{ btnValue }}</el-button
        > -->


        <!-- 丰奥  	gh_c0d69f667d5a -->
        <!-- 汉裕  	gh_eca2e453dc8e -->
        <!-- 彩虹湖 gh_1625f5546aa1 -->

        <!-- 点击跳转小程序获取手机号 -->
        <wx-open-launch-weapp id="launch-btn" username="gh_c0d69f667d5a" :path="path" @launch="onLaunch"
          @error="onError">
          <script type="text/wxtag-template">
            <style>
              .btn {
                background-color: #409EFF;
                color: #fff;
                border: none;
                text-align: center;
                font-size: 16px;
                padding: 3px 8px;
                border-radius: 3px;
                margin-right: 10px;
                borer-style:none;
              }
            </style>
            <button class="btn" @click="test">用户绑定</button>
          </script>
        </wx-open-launch-weapp>

      </div>
    </div>

    <div class="profile profile-2" v-for="item in classList" :key="item.schoolId">
      <div class="title">{{ item.schoolName }}</div>
      <div class="list-info">
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m10.png" alt="" />
            <span>所在部门</span>
          </div>
          <div class="right">{{ item.deptName }}</div>
        </div>
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m9.png" alt="" />
            <span>管理班级</span>
          </div>
          <div class="right">
            <span v-for="classes in item.classList" :key="classes.classId">{{ classes.className }}</span>
            <span v-if="!item.classList">暂无</span>
          </div>
        </div>
      </div>
    </div>
    <div class="profile profile-3" v-if="vipData.length">
      <div class="title">孩子信息</div>
      <div class="child-list">
        <div v-for="item in vipData" class="item flex" :key="item.id">
          <div class="i-1">
            <span>{{ item.name }}</span>
            <img :src="imgIcon[item.status]" alt="" />
          </div>
          <div class="i-2 flex-1">
            <div class="i-2-top">
              <span>{{ item.schoolName }}</span>
              <span>{{ item.className }}</span>
            </div>
            <!-- <div class="i-2-bottom not" @click="hrefVip(item)">
              {{ item.status == 1 ? '未订阅' : item.status == 0 && item.type == 0 ? '订阅到期时间：' + VipTime(item.expireDate)
          : item.status == 0 && item.type == 1 ? '订阅已开通' : item.status == 2 && item.type == 0 ? '订阅到期时间：' +
            VipTime(item.expireDate) : item.status == 2 && item.type == 1 ? '订阅已开通' : '' }}
              <span>&gt;</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="del-account" @click="delAccount" v-if="accountList.length > 0">
      <van-icon name="close" style="margin-right: 6px;" />
      注销账号
    </div>
    <van-popup v-model="showDel" :style="{ padding: '1rem', width: '90%' }" round @closed="clearCheckList">
      <div class="del-top">温馨提示</div>
      <div class="del-content">
        <div style="color: #666;font-size: 14px;">请选择您要注销的账号</div>
        <div class="account-list" ref="accountList">
          <div class="account-item" v-for="item in accountList" :key="item.id" @click="changeCheckList(item)">
            <div class="account-left">
              <div class="account-name">{{ item.name }} - <span style="font-size: 14px;color: #999;">{{ {
          2: '访客', 11:
            '学生', 12: '家长', 13: '老师', 14: '社区人员'
        }[item.personType] }}</span></div>
              <div class="account-info">{{ item.schoolName }} {{ item.parentName }}</div>
            </div>
            <div class="account-right">
              <div class="account-checkbox" :class="{ isChecked: checkList.includes(item.id) }">
                <img src="./check.svg" alt="" v-if="checkList.includes(item.id)" />
              </div>
            </div>
          </div>
        </div>
        <div style="color: #666;font-size: 14px;">
          注销后以下功能将不能使用，需人工方式替代，详见
          <span @click.stop="showXieyi = true" style="color: rgba(0, 101, 225, 1);">《撤回授权告知书》</span>
        </div>
        <!-- 权限列表 -->
        <div class="del-app" v-if="appList.length > 0">
          <div class="app-left">
            <div class="app-item" v-for="(item, index) in judgeShowDormList()" :key="index">
              <div class="app-item-left">
                <img src="./itemleft.png" />
              </div>
              <div class="app-item-right">
                {{ item }}
              </div>
            </div>
          </div>
          <div class="app-right">
            <img src="./warning.png" alt="" />
          </div>
        </div>
      </div>
      <div class="del-bottom">
        <van-button type="default" @click="showDel = false" round style="width: 40%;">取消</van-button>
        <van-button type="info" @click="delConfirm" round style="width: 40%;"
          :disabled="this.checkList.length == 0">确定</van-button>
      </div>
    </van-popup>
    <van-popup v-model="fkShowDel" :style="{ padding: '1rem', width: '90%' }" round>
      <div class="del-top">温馨提示</div>
      <div class="del-content">
        <div style="color: #666;font-size: 14px;text-indent: 28px;">
          您确定
          <span style="color: red;">注销</span>
          该账号下的姓名、人脸照片以 及联系方式等信息吗？注销后以下功能将不能用 需人工方式替代
        </div>
        <div class="del-app">
          <div class="app-left">
            <div class="app-item">
              <div class="app-item-left">
                <img src="./itemleft.png" />
              </div>
              <div class="app-item-right">
                校门口安全通行
              </div>
            </div>
          </div>
          <div class="app-right">
            <img src="./warning.png" alt="" />
          </div>
        </div>
      </div>
      <div class="del-bottom">
        <van-button type="default" @click="fkShowDel = false" round style="width: 40%;">取消</van-button>
        <van-button type="info" @click="delConfirm('fk')" round style="width: 40%;">确定</van-button>
      </div>
    </van-popup>
    <!-- 撤回授权告知书 -->
    <van-popup v-model="showXieyi" :style="{ padding: '1rem', width: '90%' }" round>
      <div class="xieyi-top">撤回授权告知书</div>
      <div class="xieyi-content">
        <h5>尊敬的用户：</h5>
        <p>您即将撤回对人脸信息采集与使用的授权，为保障您的权益，请仔细阅读以下说明。</p>
        <h5>一、撤回授权的直接影响</h5>
        <h5>（一）刷脸等功能关闭，您将无法使用以下依赖人脸验证的功能：</h5>
        <p>1. 校门口刷脸通行、宿舍考勤（可改用校园卡 / 人工验证放行）</p>
        <p>2. 人员轨迹追溯（改用人工查找）</p>
        <p>3. 动态心理健康评估（如需使用，需重新授权）</p>
        <h5>（二）替代验证方式：</h5>
        <p>您仍可通过以下方式正常使用平台基础服务：</p>
        <p>1. 校园卡刷卡 / 密码输入（适用于门禁、考勤）</p>
        <p>2. 人工登记（适用于访客入校、异常考勤补录）</p>
        <h5>（三）数据处理规则：</h5>
        <p>1. 已采集的人脸信息将按照《人脸采集告知书》继续安全存储，期间不会用于新的验证场景；</p>
        <p>2. 撤回后产生的新数据（如考勤记录）将不再关联人脸信息。</p>
        <h5>二、确认撤回前请知悉</h5>
        <p>1. 撤回授权后，如需重新使用刷脸功能，可通过人脸采集小程序再次申请，校方审批同意后方可正常使用。</p>
        <p>2. 未成年人用户撤回授权需监护人重新确认，详情请联系学校管理员。</p>
      </div>
      <div class="xieyi-bottom">
        <van-button type="info" @click="showXieyi = false" round style="width: 40%;">确 认</van-button>
      </div>
    </van-popup>


  </div>
</template>

<script>
import imgTrue from "@/assets/images/m12.png";
import imgFalse from "@/assets/images/m11.png";
import avatar from "@/assets/images/avatar方.png";
import moment from "moment";
import { Dialog } from "vant";
import store from "@/store";
// import Share from "@/utils/wsSDK";
export default {
  data() {
    return {
      showDel: false,
      fkShowDel: false,
      defaultAvatar: avatar,
      isEdit: false,
      show: false,
      // iconName: "edit",
      btnValue: '编辑',
      userInfo: {},
      classList: [],
      vipData: [],
      imgIcon: [imgTrue, imgFalse, imgTrue],
      phoneChanged: false,
      errmsg: false,
      personType: '',
      // 页面授权路径
      path: null,
      appList: [],
      // 要删除的人员的id
      checkList: [],
      // 家长身份
      parentsList: [],
      visitorList: [],
      residentList: [],
      showXieyi: false
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  created() {
    //  location.reload()
  },
  async mounted() {
    this.initWXConfig();

    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.userInfo);
    // if (!this.userInfo.mobile || this.userInfo.mobile === "") {
    //   this.isEdit = true;
    //   this.btnValue = "保存";
    //   Dialog.alert({
    //     title: "温馨提示",
    //     message: "请点击绑定按钮,进行身份绑定",
    //   }).then(() => {
    //     this.$nextTick(() => {
    //       this.$refs.tt.focus();
    //     });
    //   });
    // }
    this.getClassInfo();
    this.getVipData();
    // 获取家长身份
    this.getParentsList()
    // 获取访客身份
    this.getVisitorList()
    // 获取社区人员身份
    this.getCommunityList()
  },
  watch: {
    "userInfo.mobile": function (value) {
      this.phoneChanged =
        value != JSON.parse(localStorage.getItem("userInfo")).mobile;
    },
  },
  created() {
    // this.getUserInfo()
  },
  computed: {
    accountList() {
      let newList = [];

      // 老师身份
      this.classList && this.classList.map(item => {
        newList.push({
          ...item,
          id: item.id,
          name: item.teacherName,
          parentName: item.className,
          personType: 13,
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });

      // 学生身份
      this.vipData && this.vipData.map(item => {
        newList.push({
          ...item,
          id: item.id,
          name: item.name,
          parentName: item.className,
          personType: 11,
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });

      // 家长身份
      this.parentsList && this.parentsList.map(item => {
        newList.push({
          ...item,
          id: item.id,
          name: item.teacherName,
          personType: 12,
          parentName: item.className,
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });

      // 访客身份
      this.visitorList && this.visitorList.map(item => {
        newList.push({
          ...item,
          id: item.id,
          name: item.teacherName,
          personType: 2,
          parentName: item.className,
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });

      // 社区人员身份
      this.residentList.map(item => {
        newList.push({
          ...item,
          id: item.id,
          name: item.teacherName,
          personType: 14,
          parentName: item.className,
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });
      return newList;
    }
  },
  methods: {
    clearCheckList() {
      this.$refs.accountList && (this.$refs.accountList.scrollTop = 0);
      this.checkList = [];
    },

    // 判断是否展示智能宿舍归寝
    judgeShowDormList() {
      // 选中的人员类型
      let personTypeList = []
      this.accountList.map(item => {
        if (this.checkList.indexOf(item.id) != -1) {
          personTypeList.push(item.personType)
        }
      })
      // 选择了学生才有智能宿舍归寝
      if (personTypeList.includes(11)) {
        return this.appList
      } else {
        return this.appList.filter(item => {
          return item != '智能宿舍归寝'
        })
      }
    },


    changeCheckList(item) {
      if (this.checkList.indexOf(item.id) != -1) {
        this.checkList.splice(this.checkList.indexOf(item.id), 1);
      } else {
        this.checkList.push(item.id);
      }
      this.getMenus();
    },

    delAccount() {
      // if (this.userInfo.personType != 2) {
      this.showDel = true;
      this.accountList.map(item => {
        if (this.userInfo.id == item.id) {
          this.checkList.push(item.id);
          this.getMenus();
        }
      });
      this.$nextTick(() => {
        this.$refs.accountList && (this.$refs.accountList.scrollTop = 0);
      });
      // } else {
      //   this.fkShowDel = true;
      // }
    },
    // 获取多个学校额菜单信息
    getMenus() {
      let obj = {
        '/dataView/trackmanagement-face': '人员轨迹追踪',
        '/dorm/dormdept': '智能宿舍归寝',
        '/statistics/statistics-studentDay': '校门口安全通行',
        '/statistics/visitors': '校门口安全通行'
      };
      let schoolList = [];
      this.accountList.map(item => {
        if (this.checkList.indexOf(item.id) != -1) {
          schoolList.push(item.schoolId);
        }
      });

      this.$https
        .getSchoolMenuListBySchoolIds({
          schoolIds: schoolList
        })
        .then(res => {
          if (res.code == 200) {
            let list = res.data || [];
            let tempList = [];
            list.map(item => {
              if (obj[item] && tempList.indexOf(obj[item]) == -1) {
                tempList.push(obj[item]);
              }
            });
            this.appList = tempList;
          } else {
            this.appList = [];
          }
        })
        .catch(e => {
          this.appList = [];
        });
    },
    delConfirm(type) {
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      if (type == 'fk') {
        this.$https.deleteTpdUserInfoById({ deleteIds: this.userInfo.id }).then(res => {
          if (res.code == 200) {
            loading.clear();
            this.$toast('操作成功');
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        });
      } else {

        this.$https.deleteTpdUserInfoById({ deleteIds: this.checkList.join(',') }).then(res => {
          if (res.code == 200) {
            loading.clear();
            this.$toast('操作成功');
            this.showDel = false;
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        });


        // this.$https.deleteUserTemporaryMiniById({
        //   ids: this.checkList,
        //   openId: JSON.parse(localStorage.getItem('userInfo')).openId
        // }).then(res => {
        //   if (res.code == 200) {
        //     loading.clear();
        //     this.$toast('操作成功');
        //     this.showDel = false;
        //     // this.getClassInfo();
        //     // this.getVipData();
        //     // this.getParentsList()
        //     // // 获取访客身份
        //     // this.getVisitorList()
        //     // 获取社区人员身份
        //     // this.getCommunityList()
        //     setTimeout(() => {
        //       location.reload();
        //     }, 1000);
        //   }
        // });
      }
    },
    test() {
      wx.closeWindow()
    },
    onLaunch() {

      console.log("onLaunch");
      wx.closeWindow()
    },
    onError() {
      console.log("Error");
    },


    // 获取学生列表
    async getSchoolList() {
      const { code, data } = await this.$https.getSchoolList({
        // userId: this.$store.state.userId,
      });
      // console.log("信息", data);
      if (code !== 200) {
        this.list = [];
        return false;
      }
      let obj = {
        13: "老师",
        12: "家长",
        2: "访客",
      };
      if (data.patriarchList.length + data.teacherList.length === 1) {
        if (data.patriarchList.length > 0) {
          this.personType = 12;
          // console.log('我是家长开始进入选择角色了');
          this.identitySwitch(data.patriarchList[0].id);
        } else if (data.teacherList.length > 0) {
          this.personType = 13;
          // console.log('我是老师开始进入选择角色了');
          this.identitySwitch(data.teacherList[0].id);
        } else {
          this.personType = "访客";
        }
      } else {
        setTimeout(() => {
          this.$router.push({
            name: "schoolList",
            params: { hrefTo: true },
          });
        }, 500);
      }
    },
    // getUserInfo(code) {
    //   return axios.post("auth/api/autoLogin", {
    //     code,
    //     appId: store.state.appId,
    //   });
    // },

    // 微信开放标签跳转
    initWXConfig() {
      // 获取开放标签配置信息
      this.$https
        .getWXConfig({
          appid: store.state.appId,
          url: location.href.split("#")[0],
        })
        .then((res) => {
          // 跳转小程序相关配置
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp, //生成签名的时间戳
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["onMenuShareWeibo", "closeWindow"],
            openTagList: ["wx-open-launch-weapp"],
          });
        });

      wx.ready(function () {
        // wx.closeWindow()
      });
      wx.error(function (res) {
        console.log("配置失败", res);
      });
      // 配置标签跳转路径
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      let openId = JSON.parse(localStorage.getItem("userInfo")).openId;
      let token = localStorage.getItem("token");
      this.path = `pages/authPhone/indelx/indelx?loginId=${loginId}&openId=${openId}&token=${token}`;
    },


    // 身份切换
    async identitySwitch(id) {
      const { data, code } = await this.$https.identitySwitch({
        openId: JSON.parse(localStorage.getItem("userInfo")).openId,
        userId: id,
        userType: this.personType == 13 ? "1" : "2",
      });
      // return
      if (code !== 200) {
        return;
      }
      // console.log('选中角色了，重新执行查询');
      // console.log(data);
      this.$store.commit("setUserId", data.id);
      this.$store.commit("setSchoolId", data.schoolId);
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.getClassInfo();
      this.getVipData();
      this.getParentsList()
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    },
    changeMsg() {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      this.errmsg = userInfo.mobile != "" && !reg.test(this.userInfo.mobile);
    },
    VipTime(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    hrefVip(value) {
      // console.log(value);
      this.$router.push({
        name: "openvip",
        params: value,
      });
    },
    iconChange(type) {
      if (!type) {
        this.isEdit = !type;
        // this.iconName = type ? "edit" : "passed";、
        this.btnValue = type ? "编辑" : "保存";
        this.$nextTick(() => {
          this.$refs.tt.focus();
        });
      } else {
        //格式进来进入保存
        if (!this.errmsg) {
          this.isEdit = !type;
          // this.iconName = type ? "edit" : "passed";
          this.btnValue = type ? "编辑" : "保存";
          let userInfo = { ...this.userInfo };
          delete userInfo.idNumber;
          this.axios
            .post("student-consumer/api/user/updateTpdUser", userInfo)
            .then((res) => {
              if (res.code === 200) {
                if (res.data) {
                  let info = JSON.parse(localStorage.getItem("userInfo"));
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify({
                      ...info,
                      ...res.data,
                    })
                  );
                }
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                if (this.phoneChanged) {
                  this.$toast("保存成功，请进行身份切换");
                  this.getSchoolList();
                  // setTimeout(() => {
                  //   this.$router.push({
                  //     name: "schoolList",
                  //     params: { hrefTo: true },
                  //   });
                  // },500)
                }
              } else {
                this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$toast("服务器错误，请联系管理员");
            });
        }
      }
    },


    async getClassInfo() {
      if (JSON.parse(localStorage.getItem("userInfo")).mobile) {
        this.axios
          .get("student-consumer/api/user/getTeacherByPhone", {
            params: {
              mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.classList = res.data;
            } else {
              this.$toast("服务器错误，请联系管理员");
            }
          });
      }

    },
    async getVipData() {
      if (JSON.parse(localStorage.getItem("userInfo")).mobile) {
        const { code, data } = await this.$https.getParentsPayAuthChildrenList({
          mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
        });
        if (code !== 200 || !data) {
          return;
        }
        this.$store.commit("setVipData", data);
        this.childRadio = data[0].id;
        this.vipData = data;
      }

    },
    // 获取家长列表
    async getParentsList() {
      const { code, data } = await this.$https.getParentByPhone({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200 || !data) {
        return;
      }
      this.parentsList = data;
    },
    // 获取访客身份
    async getVisitorList() {
      const { code, data } = await this.$https.getVisitorByPhone({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,

      });
      if (code !== 200 || !data) {
        return;
      }
      this.visitorList = data;

    },
    // 获取社区人员
    async getCommunityList() {
      const { code, data } = await this.$https.getResidentByPhone({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200 || !data) {
        return;
      }
      this.residentList = data;

    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 15px;

  .profile {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    color: #1a1a1a;
  }
}

.profile-1 {
  padding: 10px;
  padding-right: 0px;
  position: relative;

  .avatar {
    width: 73px;
    height: 73px;
    margin-right: 17px;
    border-radius: 8px;
    overflow: hidden;
  }

  .info {
    position: relative;

    // margin-right: 20px;
    .name {
      margin-bottom: 8px;
      color: #1a1a1a;
      font-size: 16px;
    }

    .phone {
      font-size: 16px;
      color: #666;

      div {
        height: 16px;
        line-height: 16px;
      }
    }
  }

  // .icon {
  //   position: absolute;
  //   right: 45px;
  //   width: 17px;
  //   height: 17px;
  //   top: 18px;
  // }
  .input {
    border: none;
  }

  // .ninput {
  //   line-height: 21px;
  // }
}

.profile-2 {
  img {
    width: 15px;
    height: 15px;
    margin-right: 13px;
  }

  .list-info {
    .item {
      padding: 8px 15px;
      font-size: 13px;

      .left {
        color: #666666;
      }

      .right {
        width: 65%;
        display: flex;
        flex-wrap: wrap;

        span {
          margin-right: 8px;
        }
      }
    }
  }
}

.profile-3 {
  .child-list {
    .item {
      padding: 5px 23px 10px 23px;
      /* margin: 10px 0; */
      font-size: 13px;

      .i-1 {
        margin-right: 12px;
        width: 25%;
        display: flex;

        span {
          height: 15px;
          display: inline-block;
        }

        img {
          width: 14px;
          height: 14px;
          margin-left: 6px;
          margin-top: 1px;
          float: right;
        }
      }

      .i-2 {
        span:first-child {
          margin-right: 10px;
        }

        .i-2-bottom {
          font-size: 12px;
          margin-top: 6px;
          color: #666666;

          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
}

.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}

img {
  width: 100%;
  height: 100%;
}

.phoneIpt {
  padding: 0;
  font-size: 16px;
  // width: 5rem;
  outline: none;
  border: none;
  background-color: red;
  height: 16px;
  line-height: 18px;
}

.errmsg {
  position: absolute;
  bottom: -15px;
  left: 45px;
  color: red;
  font-size: 12px;
  transform: scale(0.8);
}

.del-account {
  color: #d80f0f;
  line-height: 1;
  padding: 14px;
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border-radius: 6px 6px 6px 6px;
}

.del-top {
  color: #333;
  font-size: 1rem;
  margin-bottom: 1.2rem;
  text-align: center;
}

.del-content {
  font-size: 0.73rem;

  .account-list {
    max-height: 30vh;
    overflow: auto;
    margin: 12px 0;

    .account-item {
      display: flex;
      padding: 14px 16px;
      background-color: #f7f7f9;
      border-radius: 6px;

      .account-left {
        flex: 1;

        .account-name {
          font-size: 16px;
          color: #333;
        }

        .account-info {
          font-size: 12px;
          color: #999;
          margin-top: 10px;
        }
      }

      .account-right {
        display: flex;
        flex-shrink: 0;
        align-items: center;

        .account-checkbox {
          border: 1px solid #cccccc;
          height: 12px;
          width: 12px;
          border-radius: 2px;
        }

        .isChecked {
          border-color: #0065e1;
          background-color: #0065e1;
        }
      }
    }

    .account-item+.account-item {
      margin-top: 10px;
    }
  }

  .del-app {
    background-color: #f7f7f9;
    border-radius: 6px;
    padding: 16px 30px 16px 16px;
    display: flex;
    margin-top: 10px;

    .app-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;

      .app-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
      }

      .app-item-left {
        img {
          margin-right: 6px;
          height: 10px;
          width: 6.25px;
        }
      }

      .app-item+.app-item {
        margin-top: 10px;
      }
    }

    .app-right {
      flex-shrink: 0;
      display: flex;
      align-items: center;

      img {
        height: 78px;
        width: 78px;
      }
    }
  }
}

.del-bottom {
  display: flex;
  justify-content: space-around;
  margin-top: 1.5rem;
}
.xieyi-top {
  color: #333;
  font-size: 1rem;
  font-weight: 700;

  margin-bottom: 1.2rem;
  text-align: center;
}
.xieyi-content {
  font-size: 0.85rem;
  max-height: 24rem;
  overflow: auto;
  h5,h6 {
    color: #333;
    font-weight: 700;
  }
  h5,h6,p {
    line-height: 1.5rem;
  }
  p {
    color: #666;
    text-indent: 2em;
  }
}
.xieyi-bottom {
  display: flex;
  justify-content: space-around;
  margin-top: 1.5rem;
}
</style>
